var _title, _path, _polyline, _path2, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCircleTrash = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f25f1276-e8ff-4e43-9b6f-15fe788321c5",
    "data-name": "Layer 1",
    viewBox: "0 0 43.99991 44.00006",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon-circle-trash")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,0A22,22,0,1,0,43.99991,22,22.02487,22.02487,0,0,0,22,0",
    fill: "#ff4000",
    opacity: 0.1
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "15 16.556 16.556 16.556 29 16.556",
    fill: "none",
    stroke: "#ff4000",
    strokeLinecap: "square",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.44441,16.55558V27.44447A1.55555,1.55555,0,0,1,25.88886,29H18.11108a1.55555,1.55555,0,0,1-1.55555-1.55556V16.55558m2.33333,0V15a1.55555,1.55555,0,0,1,1.55555-1.55556h3.11112A1.55556,1.55556,0,0,1,25.11108,15v1.55555",
    fill: "none",
    stroke: "#ff4000",
    strokeLinecap: "square",
    strokeWidth: 1.25
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20.44441,
    y1: 20.44447,
    x2: 20.44441,
    y2: 25.11114,
    fill: "none",
    stroke: "#ff4000",
    strokeLinecap: "square",
    strokeWidth: 1.25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 23.55553,
    y1: 20.44447,
    x2: 23.55553,
    y2: 25.11114,
    fill: "none",
    stroke: "#ff4000",
    strokeLinecap: "square",
    strokeWidth: 1.25
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCircleTrash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/circle-trash.2284da57.svg";
export { ForwardRef as ReactComponent };